import { useState } from "react";

import RichTextEditorV2 from "../../CRM/RichTextEditorV2";
import { Field } from "../../../types/TenantInterfaces";

interface Props {
  field: Field;
  startingRichText?: string;
  handleChange: any;
  title: string;
  description?: string;
}

export default function RichTextWidgetCreate({
  title,
  field,
  description,
  startingRichText,
  handleChange,
}: Props) {
  const [richText, setRichText] = useState(startingRichText || "");

  return (
    <div className="mb-3">
      <div className="py-2 mb-3 section-header">
        <div className="d-flex justify-content-between align-items-center">
          <h3 className="mb-0">{title}</h3>
        </div>
        {description && (
          <p className="mb-0">
            <small className="text-muted">{description}</small>
          </p>
        )}
      </div>
      <RichTextEditorV2
        isEditing={true}
        value={richText}
        onChange={(val: any) => {
          handleChange(field, val);
          setRichText(val);
        }}
      />
    </div>
  );
}
